module.exports = __webpack_public_path__ + "img/spreadsheet.e0131e5b.svg";